













import { defineComponent, PropType, ref, computed, toRefs } from '@vue/composition-api';
import SearchKeywords from './index';
import { MAX_INPUT_NUMBER, MAX_KEYWORD_LENGTH } from './const';
import { SearchAdsKeywordItem, CreateMode } from '@ad/tt_ads_common_enums';
import { AdgroupConfig } from '@tt4b/ttam-enums';

const name = 'ttam-search-keywords-compose';
export default defineComponent({
  name,
  components: {
    TtamSearchKeywords: SearchKeywords.TtamSearchKeywords,
  },
  props: {
    searchKeywordList: {
      type: Array as PropType<SearchAdsKeywordItem[]>,
      default: () => [],
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const maxInputNumber = ref(MAX_INPUT_NUMBER);
    const maxKeywordLength = ref(MAX_KEYWORD_LENGTH);
    const { adgroupConfig } = toRefs(props);
    const disabled = computed(() => adgroupConfig.value.disableSearchKeywords);

    function onKeywordsChange(keywordList: SearchAdsKeywordItem[]) {
      emit('on-change', keywordList);
    }

    return {
      name,
      disabled,
      maxInputNumber,
      maxKeywordLength,
      onKeywordsChange,
    };
  },
});
